import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/registro_marca/observacion';
import Observaciones from './Observaciones';


const ms2p = (state) => {
  return {
    ...state.observacion_rm,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Observaciones);
